import { createFileRoute } from "@tanstack/react-router";
import { useFaq } from "@/api/queries/faq";
import { FaqAccordion } from "@/components/support/FaqAccordion";
import { Spinner } from "@/components/ui/Spinner";

export const Route = createFileRoute("/_public/help/faq")({
	component: FaqPage,
});

function FaqPage() {
	const { data: faqItems, isLoading } = useFaq();

	if (isLoading) {
		return (
			<div className="flex justify-center py-12">
				<Spinner size="lg" label="FAQ werden geladen" />
			</div>
		);
	}

	return <FaqAccordion items={faqItems ?? []} />;
}
